export default function TexteCommune() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-3xl mx-auto px-4 md:px-8 text-center">
        <div className="w-14 h-14 flex items-center justify-center rounded-full bg-brand-light border border-brand-border mx-auto mb-6">
          <i className="ri-question-line text-2xl text-brand-cyan"></i>
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-brand-blue mb-4">
          Votre commune n'est pas listée ?
        </h2>
        <p className="text-brand-text text-base md:text-lg leading-relaxed mb-8">
          Nous intervenons dans tout le Bas-Rhin. Même si votre ville n'apparaît pas dans la liste ci-dessus, nos techniciens se déplacent dans tous les secteurs du département. N'hésitez pas à nous appeler pour vérifier la disponibilité dans votre secteur.
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4 justify-center">
          <a
            href="tel:0374473240"
            className="bg-brand-cyan text-white px-8 py-3.5 rounded-full font-semibold text-base hover:bg-brand-cyan/90 transition-colors whitespace-nowrap"
          >
            <i className="ri-phone-line mr-2"></i>
            Appeler le 03 74 47 32 40
          </a>
          <a
            href="#devis"
            className="border-2 border-brand-blue text-brand-blue px-8 py-3.5 rounded-full font-semibold text-base hover:bg-brand-blue hover:text-white transition-colors whitespace-nowrap"
          >
            Devis gratuit
          </a>
        </div>
      </div>
    </section>
  );
}